/**
 * Gets mouse coords from DOM event
 * @param {Object} event - DOM event
 * @returns {Number[]} Array of mouse coordinates
 */
export const getMouseFromDomEvent = (event = {}) => {
	// Handle touch events
	if (
		event &&
		event.type &&
		event.type.match(/touch/)
	) {
		// Assume first touch is correct location of crosshair
		const { pageX, pageY } = event.changedTouches[0];

		// Get page offset in case page has been scrolled
		const { scrollX, scrollY } = window;

		const { left, top } = event.target.getBoundingClientRect();

		return [
			(pageX - scrollX) - left,
			(pageY - scrollY) - top
		];
	}	else if (
		event &&
		event.offsetX &&
		event.offsetY
	) { // Handle mouse/pointer events (check if event is falsy because null can be passed in (CH-1119))
		return [
			event.offsetX,
			event.offsetY
		];
	}
	// Fail gracefully (effectively, there's no click on the chart)
	return [0, 0];
};

export default {
	getMouseFromDomEvent
};
